import { useData } from '@app/data/repositories';
import { SettingsScreen } from './SettingsScreen';
import { useArchive } from './useArchive';
import { useSettings } from './useSettings';

/** Версия приложения: подставляется сборкой, а не пишется руками. */
const VERSION = __APP_VERSION__;

/** Вход настроек. */
export function SettingsRoute({
  onBack,
  onOpenCase,
}: {
  onBack: () => void;
  onOpenCase: (caseId: string) => void;
}) {
  const { db, files } = useData();
  const { state, actions } = useSettings(db, files, VERSION);

  /*
   * После загрузки архива экран перечитывает хранилище: дел и документов стало больше,
   * и «1,2 ГБ в 14 делах» обязано это показать сразу, а не после следующего захода.
   */
  const archive = useArchive(db, files, VERSION, actions.refresh);

  return (
    <SettingsScreen
      state={state}
      actions={actions}
      archive={archive.state}
      archiveActions={archive.actions}
      onBack={onBack}
      onOpenCase={onOpenCase}
    />
  );
}
